import * as React from "react";
import Container from '@mui/material/Container';
import {Breadcrumbs, Button, Link, Typography, Grid, Stack, Box} from "@mui/material";
import {useNavigate} from "react-router-dom";
import './search.css';
import {Tabs} from '@mui/base/Tabs';
import {TabsList} from '@mui/base/TabsList';
import {TabPanel} from '@mui/base/TabPanel';
import TabBase from "../tab/tab";
import Result from './Result';
import {Article as ArticleIcon, Highlight as HighlightIcon,
    Soap as SoapIcon, Group as GroupIcon, Apartment as ApartmentIcon,
    QueryStats as QueryStatsIcon, Celebration as CelebrationIcon, List as ListIcon, Search as SearchIcon} from '@mui/icons-material';
import {useState, useEffect} from "react";
import { useLocation } from "react-router-dom";
import {secured as axios} from "../../axios";
import ExpandlessPlaceholder from "../placeholder/ExpandlessPlacehoder";
import {useDarkMode} from "../darkMode/hook/useDarkMode";
import {useSubmit} from "../marketPlace/hooks/useSubmit";


const Search = ({token, setShowNav}) => {
    const {mode} = useDarkMode();
    const navigate = useNavigate();
    const [disableSeeAll, setDisableSeeAll] = useState(true);
    const [disableActuality, setDisableActuality] = useState(true);
    const [disableCommunity, setDisableCommunity] = useState(true);
    const [disableEstablishment, setDisableEstablishment] = useState(true);
    const [disableAdvice, setDisableAdvice] = useState(true);
    const [disableEvent, setDisableEvent] = useState(true);
    const [disableSurvey, setDisableSurvey] = useState(true);
    const [disableService, setDisableService] = useState(true);
    const [tabValue, setTabValue] = useState(0);
    const [searchResponse, setSearchResponse] = useState([])
    const [searchInput, setSearchInput] = useState('');
    const myParam = useLocation().search;
    const input = new URLSearchParams(myParam).get("query");
    const [isLoading, setIsLoading] = useState(false);
    const {searchProduct} = useSubmit();

    const mergeObjects = (obj1, obj2) => {
        const result = {};

        Object.entries(obj1).forEach(([key, value]) => {
            result[key] = value;
        });

        Object.entries(obj2).forEach(([key, value]) => {
                result[key] = value;
        });

        return result;
    };

    const filter = (obj) => {
        const result = {};
        Object.entries(obj).forEach(([key, value]) => {
            if (key !== 'service' && key !== 'advice' && key !== 'conseil') {
                result[key] = value;
            }
        });
        return result;
    };

    useEffect( () => {

        if (input !== null) { //TO DO limiter la rechecherce à trois lettres sans caractère spéciaux
            setSearchInput(input);
            setIsLoading(true);
            axios.get(`${axios.defaults.apiURL}/search?query=${input}`).
            then(function (response) {
                console.log('response', response.data)
                searchProduct(input).then(marketPlace => {
                    console.log('marketplace', marketPlace)
                    if (marketPlace.length > 0) {
                        const formatedMarketPlace = marketPlace.reduce((acc, product) => {
                            const { category } = product;
                            if (!acc[category]) {
                                acc[category] = [];
                            }
                            acc[category].push(product);
                            return acc;
                        }, {})
                        console.log('formatedMarketPlace', formatedMarketPlace);
                        console.log('mergeObjects', mergeObjects(response.data, formatedMarketPlace));
                        setSearchResponse(mergeObjects(response.data, formatedMarketPlace));
                    } else {
                        console.log('filter', filter(response.data));
                        setSearchResponse(filter(response.data));
                    }
                    setSearchInput(input);
                    setIsLoading(false);
                });

            }).catch(function (error) {
                console.log(error)
                if (error.response.status === 401) {
                    localStorage.clear();
                    navigate('/');
                }
                setIsLoading(false);
            });
        }
    }, [input])

    useEffect(() => {
        setShowNav(true);
    }, [])

    useEffect(() => {
        console.log('______________________', tabValue)
        setTabValue(tabValue);
    }, [tabValue])

    useEffect(() => {

        setDisableActuality(true);
        setDisableService(true);
        setDisableAdvice(true);
        setDisableCommunity(true);
        setDisableEstablishment(true);
        setDisableSurvey(true);
        setDisableEvent(true);

    }, [searchResponse]);



    return <main>
                <Container className={'container'}>
                    <br/>
                    <Breadcrumbs separator="›" aria-label="breadcrumb">
                        {[
                            <Typography role='presentation' className={'breadcrumbs'} variant={'body2'} style={{color : mode.settings.breadcrumbColor1}}
                                        onClick={() => navigate('/')}>
                                Accueil
                            </Typography>,
                            <Typography role='presentation' className={'breadcrumbs'} variant={'body2'} style={{color : mode.settings.breadcrumbColor1}}
                                        onClick={() => navigate('/search')}>
                                Recherche
                            </Typography>,
                            <Typography role='presentation' variant={'body2'} style={{color : mode.settings.textColor3}}>
                                {searchInput}
                            </Typography>,
                        ]}
                    </Breadcrumbs>
                    <br/>
                    <br/>
                </Container>
                <Tabs value={tabValue} defaultValue={0} onChange={() => {console.log('fffff', tabValue); setTabValue(tabValue)}}>
                    <TabsList style={{display: "flex", flexWrap: "wrap", justifyContent: "center", gap: 3}}>
                        <Stack direction={"row"} flexWrap={"wrap"} gap={'10px'} justifyContent={'center'}>
                            <Stack direction={"row"} flexWrap={"wrap"} gap={'10px'} justifyContent={'center'}>
                                <TabBase value={0} disabled={disableSeeAll} style={{marginRight: 10 }}>
                                    <div className={'anchorButton'} style={{alignItems: ""}}
                                         onClick={() => {
                                             setTabValue(0);
                                         }}
                                    >
                                        <Typography variant={'subtitle19'}>Voir tout</Typography>
                                        <SearchIcon role="img" aria-label="Voir tous les résultats"></SearchIcon>
                                    </div>
                                </TabBase>
                                <TabBase value={1} disabled={disableActuality} style={{marginRight: 10}}  >
                                    <div className={'anchorButton'} style={{alignItems: ""}}
                                         onClick={() => {
                                             setTabValue(1);
                                         }}
                                    >
                                        <Typography variant={'subtitle19'}>Actualités</Typography>
                                        <img style={{ height : '25px', width : '35px' }}
                                             src={tabValue === 1 ? `/assets/icon/actualité-noir.png` : `/assets/icon/actuality-white.png`}
                                             alt={'Voir les résultats de catégorie Actualités'}
                                        />
                                    </div>
                                </TabBase>
                                <TabBase value={2} disabled={disableAdvice} style={{marginRight: 10}}>
                                    <div className={'anchorButton'} style={{alignItems: ""}}
                                         onClick={() => {
                                             setTabValue(2)
                                         }}
                                    >
                                        <Typography variant={'subtitle19'}>Conseils</Typography>
                                        <img style={{ height : '25px', width : '30px' }}
                                             src={tabValue === 2 ? `/assets/icon/conseil-noir.png` : `/assets/icon/conseil-white.png`}
                                             alt={'Voir les résultats de catégorie Conseils'}
                                        />
                                        {/*<HighlightIcon role="img"*/}
                                        {/*                       aria-label="Voir les résultats de catégorie Conseils"></HighlightIcon>*/}
                                    </div>
                                </TabBase>
                                <TabBase value={3} disabled={disableService} style={{marginRight: 10}}>
                                    <div className={'anchorButton'}
                                         onClick={() => {
                                             setTabValue(3)
                                         }}
                                    >
                                        <Typography variant={'subtitle19'}>Services</Typography>
                                        <img style={{ height : '25px', width : '30px' }}
                                             src={tabValue === 3 ? `/assets/icon/service-noir.png` : `/assets/icon/service-white.png`}
                                             alt={'Voir les résultats de catégorie Services'}
                                        />
                                        {/*<SoapIcon role="img"*/}
                                        {/*                  aria-label=""></SoapIcon>*/}
                                    </div>
                                </TabBase>
                            </Stack>
                            <Stack direction={"row"} flexWrap={"wrap"} gap={'10px'} justifyContent={'center'}>
                                <TabBase value={4} disabled={disableCommunity} style={{marginRight: 10}}>
                                    <div className={'anchorButton'}
                                         onClick={() => {
                                             setTabValue(4)
                                         }}
                                    >
                                        <Typography variant={'subtitle19'}>Communautés</Typography>
                                        <img style={{ height : '20px', width : '20px' }}
                                             src={tabValue === 4 ? `/assets/icon/communauté-noir.png` : `/assets/icon/communauté-white.png`}
                                             alt={'Voir les résultats de catégorie Communautés'}
                                        />
                                        {/*<GroupIcon role="img"*/}
                                        {/*                      aria-label="Voir les résultats de catégorie Communautés"></GroupIcon>*/}
                                    </div>
                                </TabBase>
                                <TabBase value={5} disabled={disableEstablishment} style={{marginRight: 10}}>
                                    <div className={'anchorButtonEtab'}
                                         onClick={() => {
                                             setTabValue(5)
                                         }}
                                    >
                                        <Typography variant={'subtitle19'}>Etablissements</Typography>
                                        <ApartmentIcon style={{fontSize : '23px'}} role="img" aria-label=""></ApartmentIcon>
                                    </div>
                                </TabBase>
                                <TabBase value={6} disabled={disableSurvey} style={{marginRight: 10}}>
                                    <div className={'anchorButton'}
                                         onClick={() => {
                                             setTabValue(6)
                                         }}
                                    >
                                        <Typography variant={'subtitle19'}>Produit</Typography>
                                        <img style={{ height : '25px', width : '30px' }}
                                             src={tabValue === 6 ? `/assets/icon/product-gray.png` : `/assets/icon/product-white.png`}
                                             alt={'Voir les résultats de catégorie Produit'}
                                        />
                                        {/*<QueryStatsIcon role="img"*/}
                                        {/*                       aria-label=""></QueryStatsIcon>*/}
                                    </div>
                                </TabBase>
                                <TabBase value={7} disabled={disableEvent} style={{marginRight: 10}}>
                                    <div className={'anchorButton'}
                                         onClick={() => {
                                             setTabValue(7)
                                         }}
                                    >
                                        <Typography variant={'subtitle19'}>Evènements</Typography>
                                        <img style={{ height : '25px', width : '40px' }}
                                             src={tabValue === 7 ? `/assets/icon/evenement-noir.png` : `/assets/icon/event-white.png`}
                                             alt={'Voir les résultats de catégorie Evènements'}
                                        />
                                        {/*<CelebrationIcon role="img"*/}
                                        {/*                           aria-label=""></CelebrationIcon>*/}
                                    </div>
                                </TabBase>
                            </Stack>
                        </Stack>
                    </TabsList>
                    <br/>

                    { !isLoading ?
                        <div>
                            <TabPanel value={0}>
                                <Result token={token} searchResponse={searchResponse}
                                        allowedResponse={['principal_community', 'actuality', 'community', 'institution', 'advice', 'service', 'event','produit']}
                                        setDisableSeeAll={setDisableSeeAll}
                                        setDisableActuality={setDisableActuality}
                                        setDisableService={setDisableService}
                                        setDisableAdvice={setDisableAdvice}
                                        setDisableCommunity={setDisableCommunity}
                                        setDisableEstablishment={setDisableEstablishment}
                                        setDisableSurvey={setDisableSurvey}
                                        setDisableEvent={setDisableEvent}
                                        sliceMax={2}
                                        setTabValue={setTabValue}
                                >
                                </Result>
                            </TabPanel>
                            <TabPanel value={1}>
                                <Result token={token}
                                        searchResponse={searchResponse}
                                        allowedResponse={['actuality']}
                                        setDisableSeeAll={setDisableSeeAll}
                                        setDisableActuality={setDisableActuality}
                                        setDisableService={setDisableService}
                                        setDisableAdvice={setDisableAdvice}
                                        setDisableCommunity={setDisableCommunity}
                                        setDisableEstablishment={setDisableEstablishment}
                                        setDisableSurvey={setDisableSurvey}
                                        setDisableEvent={setDisableEvent}
                                        sliceMax={100}
                                        setTabValue={setTabValue}
                                >
                                </Result>
                            </TabPanel>
                            <TabPanel value={2}>
                                <Result token={token}
                                        searchResponse={searchResponse}
                                        allowedResponse={['advice']}
                                        setDisableSeeAll={setDisableSeeAll}
                                        setDisableActuality={setDisableActuality}
                                        setDisableService={setDisableService}
                                        setDisableAdvice={setDisableAdvice}
                                        setDisableCommunity={setDisableCommunity}
                                        setDisableEstablishment={setDisableEstablishment}
                                        setDisableSurvey={setDisableSurvey}
                                        setDisableEvent={setDisableEvent}
                                        sliceMax={100}
                                        setTabValue={setTabValue}
                                >
                                </Result>
                            </TabPanel>
                            <TabPanel value={3}>
                                <Result token={token}
                                        searchResponse={searchResponse}
                                        allowedResponse={['service']}
                                        setDisableSeeAll={setDisableSeeAll}
                                        setDisableActuality={setDisableActuality}
                                        setDisableService={setDisableService}
                                        setDisableAdvice={setDisableAdvice}
                                        setDisableCommunity={setDisableCommunity}
                                        setDisableEstablishment={setDisableEstablishment}
                                        setDisableSurvey={setDisableSurvey}
                                        setDisableEvent={setDisableEvent}
                                        sliceMax={100}
                                        setTabValue={setTabValue}
                                >
                                </Result>
                            </TabPanel>
                            <TabPanel value={4}>
                                <Result token={token}
                                        searchResponse={searchResponse}
                                        allowedResponse={['community']}
                                        setDisableSeeAll={setDisableSeeAll}
                                        setDisableActuality={setDisableActuality}
                                        setDisableService={setDisableService}
                                        setDisableAdvice={setDisableAdvice}
                                        setDisableCommunity={setDisableCommunity}
                                        setDisableEstablishment={setDisableEstablishment}
                                        setDisableSurvey={setDisableSurvey}
                                        setDisableEvent={setDisableEvent}
                                        sliceMax={100}
                                        setTabValue={setTabValue}
                                >
                                </Result>
                            </TabPanel>
                            <TabPanel value={5}>
                                <Result token={token}
                                        searchResponse={searchResponse}
                                        allowedResponse={['institution']}
                                        setDisableSeeAll={setDisableSeeAll}
                                        setDisableActuality={setDisableActuality}
                                        setDisableService={setDisableService}
                                        setDisableAdvice={setDisableAdvice}
                                        setDisableCommunity={setDisableCommunity}
                                        setDisableEstablishment={setDisableEstablishment}
                                        setDisableSurvey={setDisableSurvey}
                                        setDisableEvent={setDisableEvent}
                                        sliceMax={100}
                                        setTabValue={setTabValue}
                                >
                                </Result>
                            </TabPanel>
                            <TabPanel value={6}>
                                <Result token={token}
                                        searchResponse={searchResponse}
                                        allowedResponse={['produit']}
                                        setDisableSeeAll={setDisableSeeAll}
                                        setDisableActuality={setDisableActuality}
                                        setDisableService={setDisableService}
                                        setDisableAdvice={setDisableAdvice}
                                        setDisableCommunity={setDisableCommunity}
                                        setDisableEstablishment={setDisableEstablishment}
                                        setDisableSurvey={setDisableSurvey}
                                        setDisableEvent={setDisableEvent}
                                        sliceMax={100}
                                        setTabValue={setTabValue}
                                ></Result>
                            </TabPanel>
                            <TabPanel value={7}>
                                <Result token={token}
                                        searchResponse={searchResponse}
                                        allowedResponse={['event']}
                                        setDisableSeeAll={setDisableSeeAll}
                                        setDisableActuality={setDisableActuality}
                                        setDisableService={setDisableService}
                                        setDisableAdvice={setDisableAdvice}
                                        setDisableCommunity={setDisableCommunity}
                                        setDisableEstablishment={setDisableEstablishment}
                                        setDisableSurvey={setDisableSurvey}
                                        setDisableEvent={setDisableEvent}
                                        sliceMax={100}
                                        setTabValue={setTabValue}
                                >
                                </Result>
                            </TabPanel>
                        </div>
                        : <Container maxWidth={"lg"}><ExpandlessPlaceholder/></Container>  }
                </Tabs>
            </main>
}

export default Search;
